import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ShimmerTable, ShimmerTitle, ShimmerCircularImage } from "react-shimmer-effects";
import Chart from 'react-apexcharts';

import OperationsStatusSLACardsThirdSectionData from '../../data/tactical-view/OperationsStatusSLACardsThirdSection.json'; 
import { RiComputerLine } from "react-icons/ri";
import { CiCalendar } from "react-icons/ci";


const OperationsStatusSLACardsThirdSection = () => {

    const [onLoading, setOnLoading] = useState(false)  

    const data = OperationsStatusSLACardsThirdSectionData;

    return (
      <div style={{
          width: '100%', marginLeft: 0, display: 'flex', flexDirection: 'column',
          marginTop: '2%', padding: 20, borderRadius: 15
      }}>



          {onLoading &&

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 100 }}>

                  <ShimmerCircularImage size={500} />
                  <ShimmerCircularImage size={500} />
              </div>
          }



          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 10 }}>


              <div style={{ width: '100%' }}>

                 


                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems:'center', flexWrap:'wrap' }}>                     



                        <div style={{
                            display: 'flex', flexDirection: 'row',
                            justifyContent: 'space-between', backgroundColor: '#fff', borderRadius: 5, width: '30%', padding: 10, 
                                paddingLeft: 20, paddingRight: 20, marginBottom:20,marginRight:20
                            }}>

                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
                                <span style={{ color: '#000', fontSize: 25,fontWeight:'bold'  }}>1550</span>
                                <span style={{ color: '#000', fontSize: 15, fontWeight:'bold'  }}>Days</span>

                               <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop:10}}>
                                    <div style={{backgroundColor:'black', color:'#fff', padding:5, borderRadius:5 }}>
                                        <RiComputerLine size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal',  marginLeft:3   }}>Host + App</span>
                                    </div>

                                    <div style={{marginLeft:10,backgroundColor:'black', color:'#fff' ,padding:5,borderRadius:5  }}>
                                        <CiCalendar size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal', marginLeft:3  }}>90 days</span>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div style={{
                            display: 'flex', flexDirection: 'row',
                            justifyContent: 'space-between', backgroundColor: '#fff', borderRadius: 5, width: '30%', padding: 10, 
                                paddingLeft: 20, paddingRight: 20, marginBottom:20, marginRight:20
                            }}>

                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
                                <span style={{ color: '#000', fontSize: 25,fontWeight:'bold'  }}>1550</span>
                                <span style={{ color: '#000', fontSize: 15, fontWeight:'bold'  }}>Days</span>

                               <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop:10}}>
                                    <div style={{backgroundColor:'black', color:'#fff', padding:5 ,borderRadius:5}}>
                                        <RiComputerLine size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal',  marginLeft:3   }}>Host + App</span>
                                    </div>

                                    <div style={{marginLeft:10,backgroundColor:'black', color:'#fff' ,padding:5, borderRadius:5 }}>
                                        <CiCalendar size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal', marginLeft:3  }}>90 days</span>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div style={{
                            display: 'flex', flexDirection: 'row',
                            justifyContent: 'space-between', backgroundColor: '#fff', borderRadius: 5, width: '30%', padding: 10, 
                                paddingLeft: 20, paddingRight: 20, marginBottom:20,marginRight:20
                            }}>

                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
                                <span style={{ color: '#000', fontSize: 25,fontWeight:'bold'  }}>1550</span>
                                <span style={{ color: '#000', fontSize: 15, fontWeight:'bold'  }}>Days</span>

                               <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop:10}}>
                                    <div style={{backgroundColor:'black', color:'#fff', padding:5,borderRadius:5 }}>
                                        <RiComputerLine size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal',  marginLeft:3   }}>Host + App</span>
                                    </div>

                                    <div style={{marginLeft:10,backgroundColor:'black', color:'#fff' ,padding:5, borderRadius:5 }}>
                                        <CiCalendar size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal', marginLeft:3  }}>30 days</span>
                                    </div>
                                </div>
                            </div>

                        </div>



                        <div style={{
                            display: 'flex', flexDirection: 'row',
                            justifyContent: 'space-between', backgroundColor: '#fff', borderRadius: 5, width: '30%', padding: 10, 
                                paddingLeft: 20, paddingRight: 20, marginBottom:20, marginRight:20
                            }}>

                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
                                <span style={{ color: '#000', fontSize: 25,fontWeight:'bold'  }}>1550</span>
                                <span style={{ color: '#000', fontSize: 15, fontWeight:'bold'  }}>Days</span>

                               <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop:10}}>
                                    <div style={{backgroundColor:'black', color:'#fff', padding:5,borderRadius:5 }}>
                                        <RiComputerLine size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal',  marginLeft:3   }}>Host</span>
                                    </div>

                                    
                                </div>
                            </div>

                        </div>



                        <div style={{
                            display: 'flex', flexDirection: 'row',
                            justifyContent: 'space-between', backgroundColor: '#fff', borderRadius: 5, width: '30%', padding: 10, 
                                paddingLeft: 20, paddingRight: 20, marginBottom:20,marginRight:20
                            }}> 

                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
                                <span style={{ color: '#000', fontSize: 25,fontWeight:'bold'  }}>1550</span>
                                <span style={{ color: '#000', fontSize: 15, fontWeight:'bold'  }}>Days</span>

                               <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop:10, }}>
                                    <div style={{backgroundColor:'black', color:'#fff', padding:5,borderRadius:5 }}>
                                        <RiComputerLine size={15}/>
                                        <span style={{ color: '#fff', fontSize: 10, fontWeight:'normal',  marginLeft:3   }}>Host + App</span>
                                    </div>

                                  
                                </div>
                            </div>

                        </div>



                  </div>



              </div>


          </div>


      </div>
  );
};

export default OperationsStatusSLACardsThirdSection;
